import { Client } from "./_clientService";

async function getSplashScreens(options: any) {
  try {
    let payload = {
      pageNo: options?.pageNo,
      limit: options?.pageSize,
      sortKey: "createdAt",
      sortDir: "DESC",
      search: options?.search,
      skipPagination: options?.skipPagination ?? false,
    };
    let path = "/splash-screen/list";
    const resp = await new Client({ path, payload }).post();

    return resp;
  } catch (error) {
    throw error;
  }
}

async function getSplashScreenInfo(splashScreenId: any) {
  try {
    const resp = await new Client({
      path: "/splash-screen/info",
      payload: {
        splashScreenId: splashScreenId,
      },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function createSplashScreen(splashScreenDetails: any) {
  try {
    const resp = await new Client({
      path: "/splash-screen/create",
      payload: splashScreenDetails,
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

async function updateSplashScreen(
  splashScreenDetails: any,
  splashScreenId: any,
) {
  try {
    const resp = await new Client({
      path: "/splash-screen/update",
      payload: { ...splashScreenDetails, _id: splashScreenId },
    }).post();
    return resp;
  } catch (error) {
    throw error;
  }
}

export async function deleteSplashScreen(splashScreenId: any) {
  const resp = await new Client({
    path: "/splash-screen/delete",
    payload: { splashScreenId },
  }).post();

  return resp;
}

export async function updateSplashScreenStatus(splashScreenId: any) {
  const resp = await new Client({
    path: "/splash-screen/update/status",
    payload: { splashScreenId },
  }).post();

  return resp;
}

export async function validateUserIds(userIds: string[]) {
  const resp = await new Client({
    path: "/splash-screen/validate-users",
    payload: { input: { userIds } },
  }).post();

  return resp;
}

export {
  getSplashScreens,
  getSplashScreenInfo,
  createSplashScreen,
  updateSplashScreen,
};
